import { action } from 'satcheljs';

export let onSelectFolderComplete = action(
    'ON_SELECT_FOLDER_COMPLETE',
    (selectedFolderId: string, previousFolderId: string, isExitingSearch: boolean) => ({
        selectedFolderId,
        previousFolderId,
        isExitingSearch,
    })
);
